// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__3xprR","modalForm":"UpgradeEpcsModal_modalForm__ru4xS","modalFooter":"UpgradeEpcsModal_modalFooter__1JsW0"};